export const fields = {
  companyName: {
    label: "Company Name",
    type: "text",
    rules: "required|string",
  },
  franchiseID: {
    label: "TDDA Supporting Region",
    rules: "required",
  },
  primaryCompanyRelationshipManager: {
    label: "TDDA Primary Relationship Manager",
    rules: "required",
    value: null,
  },
  companyType: {
    label: "National/Regional",
    value: "Regional",
  },
  leadTypeID: {
    label: "Lead Type",
  },
  industryID: {
    label: "Industry",
  },
};
